export default "__VITE_ASSET__zyMgltZG__"